/* eslint-disable no-unused-vars */
import { Button, CircularProgress, Grid } from "@mui/material";
import { createMuiTheme, ThemeProvider } from "@mui/material/styles";
import { makeStyles, withStyles } from "@mui/styles";

import PText from "../../components/pos/PText";
import PDialog from "../../components/pos/PDialog";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import { SyncUtils } from "../../utils/SyncUtils";

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { yellow } from "@mui/material/colors";
import PricingSelector from "./PricingSelector";
import BarcodeReader from "react-barcode-reader";

const useStyles = makeStyles({});

const DeptButton = withStyles((theme) => ({
  root: {
    width: "100%",
    height: "45px",
    fontSize: "0.9rem",
    color: theme.palette.getContrastText(yellow[500]),
    backgroundColor: "#ccccfe",
    "&:hover": {
      backgroundColor: yellow[700],
    },
  },
}))(Button);

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      marginNormal: {
        marginTop: 0,
        marginBottom: 0,
      },
    },
    MuiAutocomplete: {
      inputRoot: {
        '&[class*="MuiOutlinedInput-root"]': {
          padding: 0,
          "& $input": {
            padding: "5px 4px",
          },
          "& $input:first-child": {
            paddingLeft: 6,
          },
        },
      },
      input: {
        paddingTop: 0,
      },
    },

    MuiOutlinedInput: {
      input: {
        padding: 7,
        marginLeft: 2,
      },
    },
    MUIDataTableToolbar: {
      root: {
        display: "none",
      },
    },
  },
});

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default function ProductLookup(props) {
  const { t } = useTranslation();
  const translate = t;

  const [windowTitle, setWindowTitle] = useState(translate("Product Lookup"));
  const [keyboardLayout, setKeyboardLayout] = useState("default");
  const [searchTxt, setSearchTxt] = useState("");
  const [data, setData] = useState([]);
  const [productSelected, setProductSelected] = useState(false);

  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  const [value, setValue] = React.useState(0);
  const [fastItems, setFastItems] = React.useState([]);
  const [showPricingSelector, setShowPricingSelector] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const options = {
    filter: false,
    search: false,
    print: false,
    download: false,
    viewColumns: false,
    customToolbar: false,
    selectableRows: "none",
    tableBodyHeight: "450px",
    pagination: false,
    onRowClick: (rowData, rowMeta, rowIndex) => {
      resetSelection(rowMeta.rowIndex);
    },
    setRowProps: (row, dataIndex, rowIndex) => {
      if (data[rowIndex].selected) {
        return {
          style: { background: "#FFCC99" },
        };
      }
    },
  };

  useEffect(() => {
    props.setAllowBarcodeScan(false);
    initCache();
  }, []);

  useEffect(() => {
    let selected = false;
    for (let d of data) {
      if (d.selected) {
        selected = true;
      }
    }
    setProductSelected(selected);
  }, [data]);

  async function initCache() {
    setProgressMessage("Loading Product...");
    setShowProgressDialog(true);

    let fItems = [];
    for (let p of props.productCache) {
      if (p.isFastItem) {
        fItems.push(p);
      }
    }
    setFastItems(fItems);

    setShowProgressDialog(false);
  }

  useEffect(() => {
    if (searchTxt && searchTxt.length > 0) loadData(searchTxt);
    else setData([]);
  }, [searchTxt]);

  async function loadData(searchTxt) {
    let productTypes = null;
    let posFlag = null;
    console.log("props.context", props);
    if (props.context.appType === "M_POS") {
      productTypes = ["P"];
      posFlag = true;
    }
    if (props.context.appType === "R_POS") {
      productTypes = ["R"];
      posFlag = true;
    }
    let d = SyncUtils.searchInCache2(
      props.productCache2,
      searchTxt,
      100,
      productTypes,
      posFlag
    );
    setData(d);
  }

  function resetSelection(index) {
    let temp = [...data];
    for (let t of temp) {
      t.selected = false;
    }
    if (index != null) {
      temp[index].selected = true;
    }
    setData(temp);
  }

  const classes = useStyles();

  function onCloseWindow() {
    props.setAllowBarcodeScan(true);
    props.setShowProductLookup(false);
  }

  async function onSave() {
    let temp = [...data];
    for (let t of temp) {
      if (t.selected) {
        let [prodBean] = await SyncUtils.getProductBean2(t);
        if (prodBean == null) {
          alert("Product got Deleted or Modifed, please Reload the Window");
        } else {
          if (prodBean.productPricingBeanList.length == 1) {
            props.onAddProduct(prodBean, prodBean.productPricingBeanList[0]);
            props.setAllowBarcodeScan(true);
            props.setShowProductLookup(false);
          } else {
            setSelectedProduct(prodBean);
            setShowPricingSelector(true);
          }
        }
      }
    }
  }

  function onAddProduct(prodBean, pricingBean) {
    props.onAddProduct(prodBean, pricingBean);
    props.setAllowBarcodeScan(true);
    props.setShowProductLookup(false);
  }

  function isDataChanged() {
    return false;
  }

  const onChange = (input) => {};

  function onKeyPress(button) {
    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === "{shift}" || button === "{lock}") handleShift();
    else if (button === "{numbers}" || button === "{abc}") handleNumbers();
    else {
      if (button === "{backspace}") {
        setSearchTxt(searchTxt.slice(0, -1));
      } else if (button === "{ent}") {
        console.log("ENTER");
      } else if (button === "{space}") {
        setSearchTxt(searchTxt + " ");
      } else {
        setSearchTxt(searchTxt + button);
      }
    }
  }

  function handleShift() {
    let shiftToggle = keyboardLayout === "default" ? "shift" : "default";
    setKeyboardLayout(shiftToggle);
  }

  function handleNumbers() {
    let numbersToggle = keyboardLayout !== "numbers" ? "numbers" : "default";
    setKeyboardLayout(numbersToggle);
  }

  const columns = [
    {
      name: "code",
      label: translate("Code"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "name",
      label: translate("Name"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "price",
      label: translate("Price"),
      options: {
        filter: false,
        sort: true,
      },
    },
  ];

  async function onProductSelected(item) {
    let [prodBean, pricingBean] = await SyncUtils.getProductBean(item);
    if (prodBean == null || pricingBean == null) {
      alert("Product got Deleted or Modifed, please Reload the Window");
    } else {
      props.setAllowBarcodeScan(true);
      props.onAddProduct(prodBean, pricingBean);
      props.setShowProductLookup(false);
    }
  }

  const content = (
    <ThemeProvider theme={theme}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
      >
        <Tab label="Fast Items" {...a11yProps(0)} />
        <Tab label="Product Lookup" {...a11yProps(1)} />
      </Tabs>

      <TabPanel value={value} index={0}>
        <div
          style={{
            height: "500px",
            overflow: "auto",
            display: "block",
            background: "#ddd",
          }}
        >
          <Grid container>
            {fastItems.map(
              (item) =>
                item && (
                  <Grid item xs={2} style={{ padding: 3 }}>
                    <DeptButton
                      style={{
                        backgroundColor: "#ffffcb",
                      }}
                      onClick={() => {
                        onProductSelected(item);
                      }}
                    >
                      {item.name}
                    </DeptButton>
                  </Grid>
                )
            )}
          </Grid>
        </div>
      </TabPanel>

      <TabPanel value={value} index={1}>
        <Grid container style={{ height: "500px" }}>
          <Grid item xs={7}>
            <Grid container>
              <Grid item xs={12}>
                <PText
                  value={searchTxt}
                  error={""}
                  onChange={(e) => setSearchTxt(e.target.value)}
                  variant="outlined"
                  autoFocus={false}
                ></PText>
              </Grid>
              <Grid item xs={12}>
                <MUIDataTable data={data} columns={columns} options={options} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={5}>
            <Keyboard
              onChange={onChange}
              onKeyPress={onKeyPress}
              mergeDisplay={true}
              layoutName={keyboardLayout}
              layout={{
                default: [
                  "q w e r t y u i o p",
                  "a s d f g h j k l",
                  "{shift} z x c v b n m {backspace}",
                  "{numbers} {space} {ent}",
                ],
                shift: [
                  "Q W E R T Y U I O P",
                  "A S D F G H J K L",
                  "{shift} Z X C V B N M {backspace}",
                  "{numbers} {space} {ent}",
                ],
                numbers: ["1 2 3", "4 5 6", "7 8 9", "{abc} 0 {backspace}"],
              }}
              display={{
                "{numbers}": "123",
                "{ent}": "Enter",
                "{escape}": "esc ⎋",
                "{tab}": "tab ⇥",
                "{backspace}": "⌫",
                "{capslock}": "caps lock ⇪",
                "{shift}": "⇧",
                "{controlleft}": "ctrl ⌃",
                "{controlright}": "ctrl ⌃",
                "{altleft}": "alt ⌥",
                "{altright}": "alt ⌥",
                "{metaleft}": "cmd ⌘",
                "{metaright}": "cmd ⌘",
                "{abc}": "ABC",
              }}
            />
          </Grid>
        </Grid>
      </TabPanel>
    </ThemeProvider>
  );

  function onLeftButtonCLicked() {
    props.setAllowBarcodeScan(true);
    props.setShowProductLookup(false);
  }

  async function onBarcodeScanned(barcode) {
    setSearchTxt(barcode);
  }

  function rejectdBarcode(barcode) {}

  return (
    <div>
      <BarcodeReader
        onError={rejectdBarcode}
        onScan={onBarcodeScanned}
        avgTimeByChar={
          props.context.storeAdmin.barcodeScanAvgTimeByChar
            ? props.context.storeAdmin.barcodeScanAvgTimeByChar
            : 30
        }
      />
      <PDialog
        content={content}
        //title={windowTitle}
        maxWidth={"lg"}
        fullWidth={true}
        open={true}
        onCloseWindow={onCloseWindow}
        onSave={onSave}
        saveLabel={translate("Select Product")}
        isDataChanged={isDataChanged}
        saveDisabled={!productSelected}
        showLeftButton={true}
        leftButtonLabel={"Close"}
        onLeftButtonCLicked={onLeftButtonCLicked}
      ></PDialog>
      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          maxWidth={"md"}
          fullWidth={false}
          open={true}
          borderLess={true}
        ></PDialog>
      )}
      {showPricingSelector && (
        <PricingSelector
          closeWindow={setShowPricingSelector}
          product={selectedProduct}
          onAddProduct={onAddProduct}
        ></PricingSelector>
      )}
    </div>
  );
}
